// extracted by mini-css-extract-plugin
export var compactFilters = "_ea-4";
export var detailImage = "_ea-1";
export var dropdownContainer = "_ea-2";
export var imageContainer = "_ea-0";
export var selectedCard = "_ea-3";